var $gallery_slider = $('.gallery-slider');
if ($gallery_slider.children().length > 1) {
  $('.gallery-slider')
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 7000,
      dots: true,
      fade: false,
      infinite: true,
      pauseOnDotsHover: true,
      pauseOnHover: false,
      speed: 1200,
    });
}

var $gallery_slider_for = $('.gallery-slider-for');
if ($gallery_slider_for.children().length > 1) {
  $('.gallery-slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.gallery-slider-nav'
  });
  $('.gallery-slider-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 7000,
    asNavFor: '.gallery-slider-for',
    dots: true,
    fade: false,
    infinite: true,
    pauseOnDotsHover: true,
    pauseOnHover: false,
    speed: 1200,
  });
}
